import createSystemProps from "./createSystemProps";
const systemProps = createSystemProps();
export const systemPropNames = Object.keys(systemProps);
export default systemProps;
